import * as index_html from './index.html'
import * as app_js from './app.js'
import * as index_js from './index.js'
import * as paymentForm_js from './paymentForm.js'

export default [index_html, app_js, index_js, paymentForm_js]
